import React from "react";
import { H2, InternalLink, P, Strong } from "../components/Prose";

// Figures are from the pl-gami-matches table as of 23 September 2026.
export default function RarestScorelines() {
  return (
    <>
      <H2>7–4: Portsmouth v Reading, 29 September 2007</H2>
      <P>
        Eleven goals, the most in any Premier League match and still the only
        time the league has seen eleven in a single game. It is also the only
        7–4 on record, so its square on the grid shows a single 1.
      </P>

      <H2>6–4: Tottenham v Reading, 29 December 2007</H2>
      <P>
        Exactly three months after Fratton Park, Reading were on the wrong end
        of another record: the only 6–4 in Premier League history. The two
        highest-scoring matches of the 2007/08 season were both Reading
        defeats, and they are the only games of that season with ten or more
        goals.
      </P>

      <H2>9–1: Tottenham v Wigan Athletic, 22 November 2009</H2>
      <P>
        Ten goals, and the only time a Premier League side has scored nine and
        still conceded. Every other nine-goal performance in the league's
        history has come with a clean sheet: four 9–0 wins.
      </P>

      <H2>8–2: Manchester United v Arsenal, 28 August 2011</H2>
      <P>
        The only 8–2, and the only time Arsenal have conceded eight in a
        Premier League match. It was only United's third league game of the
        2011/12 season.
      </P>

      <H2>7–3: Arsenal v Newcastle, 29 December 2012</H2>
      <P>
        Sixteen months later Arsenal were on the right side of a ten-goal game:
        the only 7–3 the Premier League has produced.
      </P>

      <H2>5–5: West Brom v Manchester United, 19 May 2013</H2>
      <P>
        The only 5–5, and the only Premier League draw with more than eight
        goals. It was Sir Alex Ferguson's last match in charge of Manchester
        United, and it remains the last time the league produced a final score
        it had never seen before, counting results without regard to venue.{" "}
        <Strong>4,990 matches have been played since</Strong> without a new one.
      </P>

      <H2>A pattern in the one-offs</H2>
      <P>
        All six arrived within six years of each other, between September 2007
        and May 2013, and four clubs appear twice: Reading (7–4 and 6–4),
        Tottenham (6–4 and 9–1), Manchester United (8–2 and 5–5) and Arsenal
        (8–2 and 7–3).
      </P>

      <H2>Nearly unique: the two 8–1s</H2>
      <P>
        8–1 has happened twice, nine years apart: Nottingham Forest 1–8
        Manchester United on 6 February 1999, and Middlesbrough 8–1
        Manchester City on 11 May 2008, the final day of that season.
      </P>

      <H2>Rarer still when you count home and away</H2>
      <P>
        Split by venue, eleven results have happened exactly once. The list
        includes the two biggest away wins in Premier League history,
        Southampton 0–9 Leicester City (2019) and Sheffield United 0–8
        Newcastle (2023), plus Crystal Palace 0–7 Liverpool (2020). All three
        are recent, which is why the{" "}
        <InternalLink to="/articles/home-away-scorigami">home/away view</InternalLink>{" "}
        is where new scorigamis keep appearing. Every one-off, big win and
        high-scoring game is listed on the{" "}
        <InternalLink to="/records">records page</InternalLink>.
      </P>
    </>
  );
}
